import blackLake from './tracks/Black Lake.mp3';

/** Ambient track for the header audio toggle. Add more imports here as the library grows. */
export const ambientTrack = blackLake;
